import React from 'react';
import './KEGOC.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const KEGOC = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="kegoc">
      <div className="kegoc-content">
        <div className="kegoc-cards">
          <div className="kegoc-card" id="kegoc-card">
            <div className="kegoc-card-header">
              <h3 className="kegoc-card-title">{t.kegocTitle}</h3>
              <div className="kegoc-card-logo">
                <img 
                  src="/logos/logo-kegoc.png" 
                  alt="KEGOC"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
            <div className="kegoc-card-image">
              <img 
                src="/images/kegoc-workshop.jpg" 
                alt="KEGOC Workshop"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div className="kegoc-card-list">
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocText1}</p>
              </div>
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocText2}</p>
              </div>
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocText3}</p>
              </div>
            </div>
          </div>
          
          <div className="kegoc-card" id="kmg-card">
            <div className="kegoc-card-header">
              <h3 className="kegoc-card-title">{t.kegocKmgTitle}</h3>
              <div className="kegoc-card-logo">
                <img 
                  src="/logos/logo-kmg.png" 
                  alt="KMG Engineering"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
            <div className="kegoc-card-image">
              <img 
                src="/images/kmg-workshop.jpg" 
                alt="KMG Workshop"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div className="kegoc-card-list">
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocKmgText1}</p>
              </div>
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocKmgText2}</p>
              </div>
              <div className="kegoc-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.kegocKmgText3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KEGOC;

